<template>
  <div style="padding:10px">

    <van-tabs v-model="active">
      <van-tab title="Genel">

        <van-field :value="obje.unvan" label="Müşteri" disabled />
        <van-field :value="obje.seri + ' '+obje.sira" disabled label="Seri Sıra" />
        <van-field :value="obje.durumu" label="Durum" disabled />
        <van-field :value="obje.kim" label="Kullanici" disabled />
        <van-field :value="obje.tarih" type="text" disabled label="Dönem" />
        <van-field type="textarea" placeholder="Açıklama" rows="3" autosize :value="obje.aciklama" disabled/>


      </van-tab>
      <van-tab title="Detay">
        <van-cell-group v-for="(item, index) in obje.satir" :key="index">
          <van-cell  :title="item.isim" :label="item.kod+' # '+$helper.parabirimi(item.toplam,hesap.pb)" icon="success" style="padding-left:2px" :value="item.adet+' adet # Teslim: '+item.tadet" />
        </van-cell-group>
    </van-tab> 
      <van-tab title="Evrak" @click="active = 1">

        <van-notice-bar v-if="list.length == 0" color="#1989fa" background="#ecf9ff" left-icon="info-o"
          style="margin-top:10px">{{mesaj}}</van-notice-bar>
        <van-grid v-else :gutter="10">
          <van-grid-item v-for="(item, index) in list" :key="index">
            <van-image @click="previewShow = true"  width="2rem" height="2rem" fit="fixed" :src="item.response" />
          </van-grid-item>
        </van-grid>
        <van-divider>Evrak Yükle</van-divider>
        <van-uploader style="margin:20px" v-model="fileList" :after-read="afterRead" :delete="deletes">
          <template #preview-cover="{ file }">
            <div class="preview-cover van-ellipsis">{{ file.name }}</div>
          </template>
        </van-uploader>
        <van-button block type="pure" color="#002375" @click="upload"> EVRAK YÜKLE </van-button>

      </van-tab>
      <van-tab title="Lojistik" @click="active = 2">



</van-tab>
    </van-tabs>
      <van-image-preview v-model="previewShow" :images="list2" @change="onChange">
        <template v-slot:index>Evrak: {{ index+1 }}</template>
      </van-image-preview>
  </div>
</template>

<script>


export default {
  data() {
    return {
      previewShow:false,
      index: 0,
      hesap : this.$store.getters.getHesap,

      mesaj:'Evrak Yüklenmemiş',
      active: 0,
      obje: {},
      fileList: [],
      list:[],
      list2:[] // image popup preview

    };
  },
  created() {
    //this.depogetir()
    //this.hesap()
    this.$store.commit('setMenu',false)
    this.satisbul()
    this.filesgetir()
  },
  methods: {

    satisbul() {
      this.$store.commit("setLoading", [false, '...'])

      let index = this.$store.getters.getSatis.findIndex(obj => obj.sira == this.$route.params.id);
      if (index != -1) {
        this.obje = this.$store.getters.getSatis[index];
        console.log(this.obje.satir)
      }
    },
    upload() {
      this.$store.commit("setLoading",[true,'Bekleyin'])

      let giden = {
        dir: ['stok',this.obje.kod,this.$route.params.id],
        list: this.fileList,
        request: this.$request
      }
      this.$store.dispatch('upload', giden).then(res => {

        this.fileList = [];
        this.$store.commit("setLoading",[false,'Tamamlandı'])
      })
    },
    filesgetir() {
      this.$store.commit("setLoading",[true,'Yükleniyor'])
      this.$store.dispatch('getFiles', { request: this.$request, folder: 'stok/'+this.obje.kod+'/'+this.$route.params.id }).then(res => {
        this.list= res.data
        this.list.forEach(e => {
          this.list2.push(e.response)
        });
        this.$store.commit("setLoading",[false,'Tamamlandı'])
      })
    },
    afterRead(file) {
      let index = this.fileList.findIndex(obj => obj.file.name === file.file.name);
      Object.assign(this.fileList[index], {name:file.file.name})
    },
    onChange(index) {
      this.index = index;
    }, 
  },
};
</script>


// WEBPACK FOOTER //
// src/views/satisdetay.vue